import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import wechat from "../../../assets/images/svg/bulag.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useSpringCreateMutation, useSpringDeleteMutation, useSpringFindAllQuery, useSpringUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";
import SpringSelectorMap from "Components/MainMap/SpringSelectorMap";

import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import AuInputList from "Components/Common/AuInputList";
import ImageUploader from "Components/fileUpload/ImageUploader";
import StatusSelect from "Components/Common/StatusSelect";

const Detail = ({ searchField }: any) => {
  const [baseMap, setBaseMap] = useState<'openstreet' | 'voyager' | 'google' | 'topo'>("voyager")
  const [selectedSpring, setSelectedSpring] = useState<any>();

  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [springOne, setSpringOne] = useState<any>();
  const [springList, setSpringList] = useState<any>();
  const [springCount, setSpringCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useSpringFindAllQuery(customQuery);
  const [saveBorder, setSaveBorder] = useState<boolean>(false);

  const [springUpdate, springUpdateResult] = useSpringUpdateMutation();
  const [springCreate, springCreateResult] = useSpringCreateMutation();
  const [springDelete, springDeleteResult] = useSpringDeleteMutation();

  const {
    data: commonSpring,
    error: commonSpringError,
    isFetching: isCommonSpringFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_sprint_type`);

  useEffect(() => {
    setSpringList(data?.data);
    setLoading(false);
    setSpringCount(springList?.length);

    const tempSaveBorder = springOne !== null ? springOne?.save_border : false;
    setSaveBorder(tempSaveBorder)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, springList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setSpringOne(null);
      setIsEdit(false);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const springData = arg;
    setSpringOne({
      id: springData.id,
      code: springData.code,
      name: springData.name,
      cmd_sprint_type: springData.cmd_sprint_type,
      sea_level_m: springData.sea_level_m,
      location: springData?.location,
      save_border_desicion: springData.save_border_desicion,
      rocks_name: springData.rocks_name,
      rocks_index_geologicalage: springData.rocks_index_geologicalage,

      basin_code: springData.basin_code,
      au1_code: springData.au1_code,
      au2_code: springData.au2_code,
      au3_code: springData.au3_code,
      longitude: springData.longitude,
      latitude: springData.latitude,
      status_id: springData.status_id,
    });

    setSaveBorder(springData?.save_border)

    setIsEdit(false);
    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (springData) => {
    setSpringOne(springData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (springOne) {
      springDelete(springOne.id)
        .then((response) => {
          toastr.success("Мэдээлэл амжилттай устсан!", "Амжилттай");
        })
        .catch((error) => {
          toastr.error("Амжилтгүй!", "Амжилтгүй");
          console.log(error)
        })
      setDeleteModal(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Булаг төрөл",
        accessorKey: "sprint_type_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "далайн түвшинээс дээш метр",
        accessorKey: "sea_level_m",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Хамгаалалтын бүстэй эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border",
        cell: (cellProps: any) => {
          switch (cellProps.row.original.save_border) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Тийм
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-warning fw-semibold fs-6 text">
                  Үгүй
                </span>
              );
          }
        },
      },
      {
        header: "Хамгаалалтын бүсийн шийдвэр",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border_desicion",
      },

      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/surface/water/bulag/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const springData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(springData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const springData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(springData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code: springOne?.code,
      name: springOne?.name,
      cmd_sprint_type: springOne?.cmd_sprint_type,
      location: springOne?.location,
      save_border_desicion: springOne?.save_border_desicion,
      sea_level_m: springOne?.sea_level_m,
      rocks_name: springOne?.rocks_name,
      rocks_index_geologicalage: springOne?.rocks_index_geologicalage,

      basin_code: springOne?.basin_code ?? null,
      au1_code: springOne?.au1_code ?? null,
      au2_code: springOne?.au2_code ?? null,
      au3_code: springOne?.au3_code ?? null,
      longitude: springOne?.longitude ?? null,
      latitude: springOne?.latitude ?? null,
      status_id: springOne?.status_id ?? null,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmd_sprint_type: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sea_level_m: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_index_geologicalage: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      if (isEdit) {
        formData.append('id', springOne ? springOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_sprint_type', values?.cmd_sprint_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('rocks_name', values?.rocks_name);
        formData.append('rocks_index_geologicalage', values?.rocks_index_geologicalage);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);
        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);
        formData.append('status_id', values?.status_id);

        if (selectedSpring) {
          formData.append('geom', JSON.stringify(selectedSpring.geometry))
        }

        springUpdate(formData)
      } else {
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_sprint_type', values?.cmd_sprint_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('rocks_name', values?.rocks_name);
        formData.append('rocks_index_geologicalage', values?.rocks_index_geologicalage);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);
        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);

        if (selectedSpring) {
          formData.append('geom', JSON.stringify(selectedSpring.geometry))
        }

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
        springCreate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
            console.log(error)
          })
        setResetFiles(true);
        formData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        });
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const handleOnSpringSelected = ({ spring, longitude, latitude }) => {
    setSelectedSpring(spring);
    // const code = spring?.id?.split('.')?.[1];
    // if (code) {
    //   validation.setFieldValue('code', code);
    // }
    validation.setFieldValue('name', springOne?.name || spring?.properties?.SPR_name || "")

    validation.setFieldValue('latitude', latitude.toFixed(6));
    validation.setFieldValue('longitude', longitude.toFixed(6));
  };

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };


  return (
    <React.Fragment>
      <DeleteModal
        deleteName={springOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={wechat} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(springCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={springList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Булаг шанд мэдээлэл засах" : "Булаг шанд мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label> Булгийн бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Булгийн нэр  *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Чулуулгийн геологийн насны индекс *</Label>
                  <Input
                    name="rocks_index_geologicalage"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.rocks_index_geologicalage || ""}
                    invalid={
                      validation.touched.rocks_index_geologicalage && validation.errors.rocks_index_geologicalage
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.rocks_index_geologicalage && validation.errors.rocks_index_geologicalage ? (
                    <FormFeedback status="invalid">
                      {validation.errors.rocks_index_geologicalage}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Далайн түвшинээс дээш метр *</Label>
                  <Input
                    name="sea_level_m"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sea_level_m || ""}
                    invalid={
                      validation.touched.sea_level_m && validation.errors.sea_level_m
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                    <FormFeedback status="invalid">
                      {validation.errors.sea_level_m}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Байршил *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label >Солбицол Х</Label>
                  <Input
                    disabled
                    name="latitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.latitude || ""}
                    invalid={
                      validation.touched.latitude && validation.errors.latitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.latitude && validation.errors.latitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.latitude}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label >Солбицол У</Label>
                  <Input
                    disabled
                    name="longitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.longitude || ""}
                    invalid={
                      validation.touched.longitude && validation.errors.longitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.longitude && validation.errors.longitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.longitude}
                    </FormFeedback>
                  ) : null}
                </div>

                {!!isEdit &&
                  <StatusSelect
                    formik={validation}
                    name="status_id"
                  />
                }
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label>	Булгийн төрөл *</Label>
                  <Input
                    name="cmd_sprint_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmd_sprint_type || ""}
                    invalid={
                      validation.touched.cmd_sprint_type &&
                        validation.errors.cmd_sprint_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonSpring?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmd_sprint_type &&
                    validation.errors.cmd_sprint_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmd_sprint_type}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Ус агуулагч чулуулгийн нэр *</Label>
                  <Input
                    name="rocks_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.rocks_name || ""}
                    invalid={
                      validation.touched.rocks_name && validation.errors.rocks_name
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.rocks_name && validation.errors.rocks_name ? (
                    <FormFeedback status="invalid">
                      {validation.errors.rocks_name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хамгаалалтын бүстэй эсэх*</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setSaveBorder(!saveBorder);
                    }}
                    checked={saveBorder}
                  />
                </div>
                <div>
                  <Label>Хамгаалалтын бүсийн шийдвэр *</Label>
                  <Input
                    name="save_border_desicion"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.save_border_desicion || ""}
                    invalid={
                      validation.touched.save_border_desicion && validation.errors.save_border_desicion
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                    <FormFeedback status="invalid">
                      {validation.errors.save_border_desicion}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <AuInputList
                    formik={validation}
                    showBasin
                    showAu1
                    showAu2
                    showAu3
                  />
                </div>

                {springOne?.id &&
                  <div className="mb-3">
                    <Label>	Зураг оруулах </Label>
                    <ImageUploader
                      tableName="spring"
                      connectionId={springOne.id}
                      valueGroup="test"
                      accept={[".jpeg", ".jpg", ".png"]}
                      multiple
                    />
                  </div>
                }
              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'point'} />
              </Row>
            }
            <Row>
              <Col lg="12">
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <SpringSelectorMap baseMap={baseMap} initialLongitude={springOne?.longitude} initialLatitude={springOne?.latitude} onSpringSelected={handleOnSpringSelected} />
              </Col>
            </Row>
          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
